// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bm_W","textarea":"styles_textarea__z1W-f"};